import { Stack } from "@mui/material";
import { useContext } from "react";

import BackBtn from "../../../Common/BackBtn";
import CrossExitBtn from "../../../Common/InfoStep/components/CrossExitBtn/CrossExitBtn";
import ThemeContext from "../../../context";
import EntityLogo from "../EntityLogo";

type Props = {
	onPressBack: () => void;
};

// ----------------------------------------------------------------------

export const FundSelectionHeader = ({ onPressBack }: Props) => {
	const themeContext = useContext(ThemeContext);
	const { theme, isFrame } = themeContext;

	return (
		<Stack
			flexDirection={"row"}
			alignItems={"center"}
			gap={2}
			sx={{ mb: 3 }}
			justifyContent={"space-between"}
		>
			<BackBtn onClick={onPressBack} />
			{!isFrame && theme?.showExit && <CrossExitBtn />}
			<EntityLogo />
			<div />
		</Stack>
	);
};

export default FundSelectionHeader;
